/** Device-local, bounded diagnostics. Never accepts free text, URLs, IDs or content. */
export type DiagnosticCode = 'request_timeout' | 'request_network_error' | 'render_error' | 'socket_disconnected' | 'event_rejected'
const events: Array<{ code: DiagnosticCode; at: string }> = []
export function recordDiagnostic(code: DiagnosticCode): void {
  if (!['request_timeout', 'request_network_error', 'render_error', 'socket_disconnected', 'event_rejected'].includes(code)) return
  events.push({ code, at: new Date().toISOString() })
  if (events.length > 50) events.shift()
}
export function diagnosticsReport(): string {
  return JSON.stringify({ format: 1, generated_at: new Date().toISOString(), online: navigator.onLine, events }, null, 2)
}
